(() => {
  const SELECTOR = '[data-ttd-mobile-buybar]';
  const MOBILE_QUERY = '(max-width: 749px)';

  class TTDProductBuyBar {
    constructor(bar) {
      this.bar = bar;
      this.productInfo = bar.closest('product-info');
      this.infoContainer = this.productInfo?.querySelector('.product__info-container');
      this.proxyButton = bar.querySelector('[data-ttd-mobile-buybar-button]');
      this.priceOutput = bar.querySelector('[data-ttd-mobile-buybar-price]');
      this.mediaQuery = window.matchMedia(MOBILE_QUERY);
      this.sourceButton = null;
      this.sourceVisible = false;
      this.productVisible = false;
      this.frame = null;

      if (!this.productInfo || !this.infoContainer || !this.proxyButton) {
        this.bar.remove();
        return;
      }

      this.sourceObserver = new IntersectionObserver(
        (entries) => {
          this.sourceVisible = entries.some((entry) => entry.isIntersecting);
          this.updateVisibility();
        },
        { threshold: 0.2 }
      );

      this.productObserver = new IntersectionObserver(
        (entries) => {
          this.productVisible = entries.some((entry) => entry.isIntersecting);
          this.updateVisibility();
        },
        { threshold: 0 }
      );
      this.productObserver.observe(this.productInfo);

      this.contentObserver = new MutationObserver(() => this.scheduleSync());
      this.contentObserver.observe(this.infoContainer, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });

      this.proxyButton.addEventListener('click', () => {
        this.sync();
        if (!this.sourceButton || this.proxyButton.disabled) return;
        this.sourceButton.click();
      });

      this.infoContainer.addEventListener('change', () => this.scheduleSync());
      this.mediaQuery.addEventListener('change', () => this.updateVisibility());
      this.sync();
    }

    scheduleSync() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        this.sync();
      });
    }

    sync() {
      const nextSource = this.infoContainer.querySelector('.product-form__submit');
      if (nextSource !== this.sourceButton) {
        if (this.sourceButton) this.sourceObserver.unobserve(this.sourceButton);
        this.sourceButton = nextSource;
        this.sourceVisible = false;
        if (this.sourceButton) this.sourceObserver.observe(this.sourceButton);
      }

      if (!this.sourceButton) {
        this.setVisible(false);
        return;
      }

      const disabled =
        this.sourceButton.disabled ||
        this.sourceButton.getAttribute('aria-disabled') === 'true';
      const label = this.sourceButton.textContent.trim();
      this.proxyButton.disabled = disabled;
      if (label) this.proxyButton.textContent = label;

      const priceItems = [...this.infoContainer.querySelectorAll('[id^="price-"] .price-item')];
      const visiblePrice = priceItems.find((item) => item.getClientRects().length > 0);
      if (visiblePrice && this.priceOutput) this.priceOutput.textContent = visiblePrice.textContent.trim();

      this.updateVisibility();
    }

    updateVisibility() {
      this.setVisible(this.mediaQuery.matches && this.productVisible && !this.sourceVisible);
    }

    setVisible(visible) {
      this.bar.dataset.visible = visible ? 'true' : 'false';
      this.bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
  }

  const initialise = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((bar) => {
      if (bar.dataset.ttdInitialised === 'true') return;
      bar.dataset.ttdInitialised = 'true';
      new TTDProductBuyBar(bar);
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
